/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameIcon64Regular = forwardRef('ScanFrameIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M57 15.5A8.5 8.5 0 0 0 48.5 7h-6a1.5 1.5 0 0 0 0 3h6a5.5 5.5 0 0 1 5.5 5.5v6a1.5 1.5 0 0 0 3 0v-6Z" }),
        React.createElement("path", { d: "M15.5 57A8.5 8.5 0 0 1 7 48.5v-6a1.5 1.5 0 0 1 3 0v6a5.5 5.5 0 0 0 5.5 5.5h6a1.5 1.5 0 0 1 0 3h-6Z" }),
        React.createElement("path", { d: "M48.5 57a8.5 8.5 0 0 0 8.5-8.5v-6a1.5 1.5 0 0 0-3 0v6a5.5 5.5 0 0 1-5.5 5.5h-6a1.5 1.5 0 0 0 0 3h6Z" }),
        React.createElement("path", { d: "M15.5 7A8.5 8.5 0 0 0 7 15.5v6a1.5 1.5 0 0 0 3 0v-6a5.5 5.5 0 0 1 5.5-5.5h6a1.5 1.5 0 0 0 0-3h-6Z" })));
});
